import { IOrganizationAddressModel } from './model';

export default (self: IOrganizationAddressModel) => ({
  get location() {
    return `${self.city}, ${self.state} ${self.zip_code}, ${self.country}`;
  }
});
